import { HomePicture, HomeGroupLayout } from 'components';
import React from 'react';


/**
 * 相片頁面
 */

export const HomePicturePage = () => {
  return (
    <HomeGroupLayout>
      <HomePicture />
    </HomeGroupLayout>
  );
};
